import { combineReducers } from 'redux'

import companyDashboard from 'src/store/modules/dashboard/companyDashboard'
import performanceDashboard from 'src/store/modules/dashboard/performanceDashboard'
import telemedicineDashboard from 'src/store/modules/dashboard/telemedicineDashboard'

export default combineReducers({
  companyDashboard,
  performanceDashboard,
  telemedicineDashboard
})

export * from 'src/store/modules/dashboard/companyDashboard'
export * from 'src/store/modules/dashboard/performanceDashboard'
export * from 'src/store/modules/dashboard/telemedicineDashboard'
